import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { DocumentFile, DocumentsState } from "./document-state";

const initialState: DocumentsState = {
    filesDocument: [],
    isDraggingDocument: false,
    isUpdateDocuments: false,
};

const documentSlice = createSlice({
    name: "documentSlice",
    initialState,
    reducers: {
        selectAddFilesDocument: (state, action: PayloadAction<File[]>) => {
            const startId =
                state.filesDocument.length > 0
                    ? Math.max(...state.filesDocument.map(item => item.id)) + 1
                    : 0;

            const newFiles: DocumentFile[] = action.payload.map((file, index) => ({
                id: startId + index,
                file,
                fileName: file.name,
                filePath: "",
                type: "new",
            }));

            state.filesDocument.push(...newFiles);
        },
        removeAllNewFilesDocuments: (state) => {
            state.filesDocument = state.filesDocument.filter(
                item => item.type !== "new"
            );
        },
        populateFilesDocuments: (state, action: PayloadAction<{ fileName: string, filePath: string}[] | null>) => {
            state.filesDocument = (action.payload ?? []).map((item, index) => ({
                id: index,
                file: null,
                fileName: item.fileName,
                filePath: item.filePath,
                type: "old",
            }));
        },

        removeFileDocuments: (state, action: PayloadAction<number>) => {
            state.filesDocument = state.filesDocument.filter(
                item => item.id !== action.payload
            );
        },

        clearFilesDocuments: (state) => {
            state.filesDocument = [];
        },

        setDraggingDocuments: (state, action: PayloadAction<boolean>) => {
            state.isDraggingDocument = action.payload;
        },
        setIsUpdateDocuments: (state, action: PayloadAction<boolean>) => {
            state.isUpdateDocuments = action.payload;
        },
    },
});

export const { 
    selectAddFilesDocument,
    removeFileDocuments,
    clearFilesDocuments,
    setDraggingDocuments,
    populateFilesDocuments,
    setIsUpdateDocuments,
    removeAllNewFilesDocuments,
} = documentSlice.actions;

export const selectFileDocuments = (state: RootState) => state.documentSlice.filesDocument;
export const selectIsDraggingDocuments = (state: RootState) => state.documentSlice.isDraggingDocument;
export const selectIsUpdateDocuments = (state: RootState) => state.documentSlice.isUpdateDocuments;


export default documentSlice.reducer;
